import React from "react";
function NotFound() {
  return (
    <div className="container p-5 text-center landing-content">
      <div className="row">
        
        <h1 className="mt-5 ">404 Not Found</h1>
        <p>
       We couldn’t find the page you were looking for.
        </p>
        
      </div>
    </div>
  );
}

export default NotFound;
